import EventEmitter from 'eventemitter2';

/**
 * 
 * Base class for Bootstrap Modules 
 * Bootstrap modules are used to customize the behavior of the website life-cycle
 *
 * @extends EventEmitter
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class Module extends EventEmitter{
	/**
	 * Instanciate a new Module
 	 * @param {Bootstrap} bootstrap A {@link Bootstrap} object
	 */
	constructor(bootstrap){
		super();
		this.bootstrap 	= bootstrap;
		this._dependencies = new Set();
		this._enabled = false;
	}

	/**
	 * The module priority, the higher, the strongest. Default is 0
	 * 
 	 * @type {number}
	 */
	get priority(){
		return 0;
	}

	/**
	 * Enables or disable the module
	 * 
 	 * @type {boolean}
	 */
	get enabled(){
		return this._enabled;
	}
	set enabled(enabled){
		if(this._enabled != enabled){
			this._enabled = enabled;
		}
	}

	/**
	 * The dependencies Set object. It is used to validate the use of a module when it depends on another module of the bootstrap.
	 * 
 	 * @return {Set} the dependency Set
	 */
	get dependencies(){
		return this._dependencies;
	}

	/**
	 * Test the validity of the Module. It checks that the dependencies exists in the bootstrap.
	 * 
 	 * @return {boolean} true if the current module is runnable 
	 */
	get runnable(){
		return this.enabled && Array.from(this.dependencies).every(dependency => this.bootstrap.modules.has(dependency));
	}
	/**
	 * This method is run prior by the bootstrap. It's intended to prepare the module to be run later.
	 * 
	 * @async
	 * @abstract
	 */
	init(){}

	/**
	 * This method is run first by the bootstrap. It's intended to prepare the module to be run later.
	 * 
	 * @async
	 * @abstract
	 */
	async before(){}

	/**
	 * The main method of a module, it should run the actual behavior of a module.
	 *
	 * @async
	 * @abstract
	 */
	async run(){}

	/**
	 * This method is run last by the bootstrap. It's intended to cleanup the module after it has been run.
	*
	 * @async
	 * @abstract
	 */
	async after(){}
}

export default Module;
export { Module };